import { Box, Button, Text, config, toRem } from 'folds';
import { BRAND_TAGLINE, SOURCE_URL, SUPPORT_URL } from '../../brand';
import { Code, Heart, menuIcon } from '$components/icons/phosphor';
import { Page, PageHero, PageHeroSection } from '$components/page';
import { versionLabel } from '$utils/platform';
import LogoSVG from '$public/res/svg/logo.svg';

export function WelcomePage() {
  return (
    <Page>
      <Box
        grow="Yes"
        style={{ padding: config.space.S400, paddingBottom: config.space.S700 }}
        alignItems="Center"
        justifyContent="Center"
      >
        <PageHeroSection>
          <PageHero
            icon={<img width="70" height="70" src={LogoSVG} alt="SAWA Logo" />}
            title="Welcome to SAWA"
            subTitle={
              <span>
                {BRAND_TAGLINE}{' '}
                <a href={SOURCE_URL} target="_blank" rel="noreferrer noopener">
                  {versionLabel()}
                </a>
              </span>
            }
          >
            <Box justifyContent="Center">
              <Box grow="Yes" style={{ maxWidth: toRem(300) }} direction="Column" gap="300">
                <Button
                  as="a"
                  href={SOURCE_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  before={menuIcon(Code)}
                >
                  <Text as="span" size="B400" truncate>
                    Source code
                  </Text>
                </Button>
                <Button
                  as="a"
                  href={SUPPORT_URL}
                  target="_blank"
                  rel="noreferrer noopener"
                  fill="Soft"
                  before={menuIcon(Heart)}
                >
                  <Text as="span" size="B400" truncate>
                    Help
                  </Text>
                </Button>
              </Box>
            </Box>
          </PageHero>
        </PageHeroSection>
      </Box>
    </Page>
  );
}
